import * as React from 'react';
import { useSelector } from 'react-redux';
import { trackRoomsCountClick } from '../../../../analytics';
import { selectFilters } from '../../../../selectors';
import { useActions } from '../useActions';
import { ALL, jkRoomsCountSelectorOptions } from '../../../../constants/jkRoomsCountSelectorOptions';

/** Пропсы для фильтра выбора комнатности */
export var useJkRoomsCountSelectorProps = function useJkRoomsCountSelectorProps() {
  var _useSelector = useSelector(selectFilters),
      jkRoomsCount = _useSelector.jkRoomsCount,
      estimationTarget = _useSelector.estimationTarget;

  var _useActions = useActions(),
      setJkRooms = _useActions.setJkRooms;

  var onValueChange = React.useCallback(function (value) {
    var nextValue = null;

    if (value !== ALL && jkRoomsCount !== value) {
      nextValue = value;
    }

    setJkRooms({
      jkRoomsCount: nextValue
    });
    trackRoomsCountClick(estimationTarget);
  }, [setJkRooms, jkRoomsCount, estimationTarget]);
  return {
    value: jkRoomsCount || ALL,
    onValueChange: onValueChange,
    values: jkRoomsCountSelectorOptions,
    placeholder: 'Любая комнатность',
    //TODO убрать из типизации, т.к поле необязательно
    errorMessage: ''
  };
};